import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { goToAddNewPayeePage, setBackPage, setSharedData } from '../states/page/actions';
import { isAddPayeeEnable } from '../states/accounts/selectors';
import { getPage } from '../states/page/selectors';
import { getSelectedPaymentId } from '../states/payeeSelector/selectors';

const mapState = (state, props) => ({
	isAddPayeeEnable: isAddPayeeEnable(state, props.fromAccountId),
	selectedPaymentId: getSelectedPaymentId(state),
	currentPage: getPage(state),
});
const mapDispatch = (dispatch) => ({
	handleAddPayeePageNavigation: () => dispatch(goToAddNewPayeePage()),
	setBackPage: (currentPage) => dispatch(setBackPage(currentPage)),
	setSharedData: (data) => dispatch(setSharedData(data)),
});

export default (WrappedComponent) => {
	const withAddPayee = class extends Component {
		constructor(props) {
			super(props);
			this.handleAddPayee = this.handleAddPayee.bind(this);
		}
		handleAddPayee() {
			const { handleAddPayeePageNavigation, currentPage, setBackPage, fromAccount, setSharedData, selectedPaymentId } =
				this.props;
			if (fromAccount) {
				setSharedData({ fromAccountId: fromAccount, canAddMultiplePayments: !selectedPaymentId, selectedPaymentId });
			}
			setBackPage(currentPage);
			handleAddPayeePageNavigation();
		}
		render() {
			const { isAddPayeeEnable } = this.props;
			return (
				<WrappedComponent {...this.props} handleAddPayee={this.handleAddPayee} isAddPayeeEnable={isAddPayeeEnable} />
			);
		}
	};

	withAddPayee.displayName = `withAddPayee(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

	withAddPayee.propTypes = {
		handleAddPayeePageNavigation: PropTypes.func.isRequired,
		isAddPayeeEnable: PropTypes.bool.isRequired,
		canAddMultiplePayments: PropTypes.bool,
		currentPage: PropTypes.string.isRequired,
		setBackPage: PropTypes.func.isRequired,
		fromAccountId: PropTypes.string,
		fromAccount: PropTypes.string,
		selectedPaymentId: PropTypes.string,
		setSharedData: PropTypes.func.isRequired,
	};

	return connect(mapState, mapDispatch)(withAddPayee);
};
